(() => {
  const D = window.__dxDict;
  if (!D) return;
  const SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1 };
  const SUBS = ['White body, black long sleeves, bold black front print.'];
  const tr = (s) => {
    const t = s.trim();
    if (!t) return null;
    if (D[t]) return s.replace(t, D[t]);
    let m = t.match(/^Buy now(.*)$/);
    if (m && D['Buy now']) return s.replace(t, D['Buy now'] + m[1]);
    m = t.match(/^Select size (\S+)$/);
    if (m && D['Select size']) return s.replace(t, `${D['Select size']} ${m[1]}`);
    for (const k of SUBS) if (t.includes(k) && D[k]) return s.replace(k, D[k]);
    return null;
  };
  const walk = (n) => {
    if (n.nodeType === 3) { const r = tr(n.nodeValue); if (r !== null && r !== n.nodeValue) n.nodeValue = r; return; }
    if (n.nodeType !== 1 || SKIP[n.tagName]) return;
    if (n.placeholder && D[n.placeholder]) n.placeholder = D[n.placeholder];
    n.childNodes.forEach(walk);
  };
  walk(document.body);
  new MutationObserver((ms) => ms.forEach((m) => {
    if (m.type === 'characterData') walk(m.target); else m.addedNodes.forEach(walk);
  })).observe(document.body, { childList: true, subtree: true, characterData: true });
  if (D.You) {
    const st = document.createElement('style');
    st.textContent = `.dx-bar__you::after{content:${JSON.stringify(D.You)}}`;
    document.head.appendChild(st);
  }
})();